import i18n from '../i18n/config';
import { BLOG_ROUTES, type BlogId, type Locale } from '../constants/blogRoutes';
import Header from './Header';
import Footer from './Footer';

const getCurrentLocale = (): Locale => {
  const locale = (i18n.locale || document.documentElement.lang || 'lv') as Locale;
  return ['en', 'lv', 'ru'].includes(locale) ? locale : 'lv';
};

const getBlogTitle = (id: BlogId): string => {
  return i18n.t(`blogs.${id}.title`) as string;
};

const getBlogImageName = (id: BlogId): string => {
  return i18n.t(`blogs.${id}.image_name`) as string;
};

const getBlogHeading = (id: BlogId): string => {
  return i18n.t(`blogs.${id}.content.heading`) as string;
};

const getIndexTitle = (): string => {
  return i18n.t('meta.blogs_page_title') as string;
};

const BlogsPage = () => {
  const locale = getCurrentLocale();

  return (
    <div className="min-h-screen flex flex-col">
      <Header currentLanguage={i18n.locale} />

      <main className="flex-grow">
        <section
          className="relative overflow-hidden bg-gradient-to-br from-[#2c3e50] to-[#3498db] py-16 text-white"
          aria-labelledby="blogs-section-heading"
        >
          <div className="absolute inset-0 bg-[url('/pattern.png')] opacity-20" />
          <div className="container relative z-10 mx-auto px-4">
            <h1 id="blogs-section-heading" className="text-4xl font-bold leading-tight sm:text-5xl">
              {getIndexTitle()}
            </h1>
          </div>
        </section>

        <section className="bg-gradient-to-br from-white to-[#f9fafb] py-12 sm:py-16">
          <div className="container mx-auto max-w-5xl px-4">
            <ul className="divide-y divide-slate-200">
              {BLOG_ROUTES.map((blog) => {
                const href = `/${locale}/blogs/${blog.slug[locale]}`;
                const title = getBlogTitle(blog.id);
                const heading = getBlogHeading(blog.id);
                const imageSrc = `/images/blogs/${getBlogImageName(blog.id)}`;

                return (
                  <li key={blog.id}>
                    <a href={href} className="group block py-6 sm:py-7">
                      <div className="flex items-start gap-4">
                        <img
                          src={imageSrc}
                          alt={title}
                          className="h-14 w-20 shrink-0 rounded-md object-cover"
                        />
                        <div className="min-w-0">
                          <h2 className="text-xl font-semibold text-[#2c3e50] transition-colors group-hover:text-[#3498db] sm:text-2xl">
                            {title}
                          </h2>
                          <p className="mt-2 line-clamp-2 text-base leading-relaxed text-[#2c3e50]/80">
                            {heading}
                          </p>
                        </div>
                      </div>
                    </a>
                  </li>
                );
              })}
            </ul>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default BlogsPage;
